import s from '../Label.module.css';
const GalleryLabel = () => {
  return <div className={s.menu__label}>Gallery</div>;
};

export { GalleryLabel };
